import { render, staticRenderFns } from "./vue-echarts.vue?vue&type=template&id=50b899bd"
import script from "./vue-echarts.vue?vue&type=script&lang=js"
export * from "./vue-echarts.vue?vue&type=script&lang=js"
import style0 from "./vue-echarts.vue?vue&type=style&index=0&id=50b899bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports